module.exports = __webpack_public_path__ + "img/Cookie_1_resize_12.39fcb429.png";